import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Cut = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, cutArticleInstances } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            cutArticleInstances: state.cutArticleInstances
        }))
    );

    const hasSelection = (() => {
        for (const _ in articleInstanceSelections) {
            return true;
        }
        return false;
    })();

    return (
        <Menu.Item
            disabled={!hasSelection}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="content_cut" />
            }
            rightSection={
                <ActionShortcutHint actionId={InputActionId.ArticleCut} />
            }
            onClick={() => cutArticleInstances()}
        >
            {t('labelCut')}
        </Menu.Item>
    );
};
